$(document).on("click", ".insights a.adjacent-period", function (e) {
  e.preventDefault()
  const $form = $("form#search-filter-statuses-form")
  let $ds = $("form#search-filter-statuses-form input[name=ds]")
  let $de = $("form#search-filter-statuses-form input[name=de]")
  $ds.val($(this).data("ds"))
  $de.val($(this).data("de"))
  $form.submit()
})
